ike-footer {
  margin-top:auto;

  footer {
    background-color: $white;
    background-color: var(--white);
    padding: 60px 0;

    .EMBEDED & {
      margin-top: 30px;
      background: transparent;
      padding: 30px 0;
      .footer-embeded {
        flex-direction: inherit;
        align-items: center;
        justify-content: space-between;

        p {
          margin-bottom: 0;
        }
      }
    }
    .MD &{
      text-align: center;
      padding: 40px 0;

      .wrap {
        display: block;
      }
    }

    .SM &{
      padding: 30px 0;
    }

    .footer-line {
      ike-modal {
        h2.ike-modal-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;

          i {
            cursor: pointer;
          }
        }
      }
      .phone, .email, .link{
        color: $main-color;
        color: var(--main-color);
        cursor: pointer;
      }
      .phone {
        margin-bottom: 10px;
      }
      display: flex;
      flex-direction: column;
      gap: 5px;
      > p,span {
        display: inline-flex;
        align-items: center;
      }
      a {
        margin-bottom:0px;
      }
      .powered_by {
        margin-bottom:10px;

        .EMBEDED & {
          a {
            margin: 0 0 !important;

            img {
              width: 100px !important;
            }
          }
        }

        img {
          width: 130px;
          border-radius: 0;
        }
      }
      .underline {
        text-decoration: underline;
      }

      .EMBEDED & {
        display: none;
      }
      .MD &{
        margin-bottom: 40px;

        &.powered {
          > p {
            align-items: baseline;
            display: flex;

            a {
              font-size: 20px;
              line-height: 28px;
              margin: 0 0 0 2px;
            }

            .create-ticketing {
              font-size: 14px;
              color: $main-color;
              color: var(--main-color);
            }
          }
        }

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      &.footer-embeded {
        display: none;
        width: 100%;

        .EMBEDED.MD & {
          .select-container, .buttons-container {
            justify-content: center;
            margin-bottom: 30px;
          }
        }

        .EMBEDED & {
          display: flex;

          .select-container {
            display: flex;
            align-items: center;
            justify-content: center;

            ike-dropdown {
              margin-right: 28px;

              .button.btn-cart {
                color: $gray-dark;
                color: var(--gray-dark);

                i {
                  color: $gray-dark;
                  color: var(--gray-dark);
                  margin-left: 5px;
                }
              }

              .button {
                font-size: 14px;
                text-transform: uppercase;
              }

              .icon-chevron-down {
                font-size: 10px;
              }

              .dropdown__link {
                text-transform: uppercase;
              }
            }
          }

          .buttons-container {
            display: flex;
            align-items: center;

            a {
              display: flex;
              align-items: center;
              color: $gray-dark;
              color: var(--gray-dark);
              margin-right: 35px;
              font-size: 14px;
              font-weight: 500;
              line-height: 18px;
              cursor: pointer;
              margin-bottom: 0;

              &:last-of-type {
                margin-right: 0;
              }

              i {
                color: $gray-dark;
                color: var(--gray-dark);
                margin-right: 5px;
                font-size: 15px;
              }
            }
          }

          p {
            align-items: center;
            display: flex;
            color: $gray-dark;
            color: var(--gray-dark);
            a {
              margin: 0 5px;
            }
          }
        }

        .MD & {
          display: block;
        }
      }
    }

    .wrap {
      display: flex;
      justify-content: space-between;
    }

    h2 {
      margin-bottom: 10px;
    }

    a, p {
      font-size: 16px;
      line-height: 21px;

      .MD &{
        font-size: 14px;
        margin-bottom: 5px;
        line-height: 18px;
        justify-content: center;
      }
    }

    a {
      color: $main-color;
      color: var(--main-color);
      display: block;
      margin-bottom: 10px;
      text-decoration: none;

      .MD &{
        align-items: center;
        display: flex;
      }
    }

    i {
      color: $gray-medium;
      color: var(--gray-medium);
      font-size: 20px;
    }

    .icon-phone, .icon-email-action-unread, .icon-tickets-exchange{
      margin-right: 10px;
    }

    .exchange{
      margin-top: 10px;
      width: fit-content;
      a{
        display: flex;
        align-items: center;
      }
      .MD &{
        margin: auto;
      }
      .icon-tickets-exchange{
        color: $main-color-text;
        color: var(--main-color-text);
      }
    }

    .social {
      align-items: center;
      display: flex;

      .MD &{
        justify-content: center;
      }

      a {
        margin-right: 20px;

        .MD &:last-of-type {
          margin-right: 0;
        }
      }

    }
    .only_embeded{
      visibility: hidden;
    }
    .EMBEDED & {
      .only_embeded{
        visibility: visible;
      }
    }
  }
}
